export default "__VITE_ASSET__DDlFqcIn__"